/** Premium status strip (aligned with dashboard “Status: Verstuurd” pattern). */
export function toastStatusForType(type) {
  switch (type) {
    case "success":
      return { label: "Voltooid", tone: "emerald" };
    case "warning":
      return { label: "In verwerking", tone: "amber" };
    case "error":
      return { label: "Fout", tone: "red" };
    case "info":
    default:
      return { label: "Nieuw", tone: "emerald" };
  }
}

const toneClass = {
  emerald: "text-emerald-600 dark:text-emerald-400",
  amber: "text-amber-600 dark:text-amber-400",
  red: "text-red-600 dark:text-red-400",
  muted: "text-wa-muted font-semibold",
};

export function toastStatusToneClass(tone) {
  return toneClass[tone] || toneClass.emerald;
}
